import { FC, useEffect, useState } from 'react';
import { FormProvider, useForm } from "react-hook-form";
import { SelectChangeEvent, Autocomplete, TextField, Tooltip, Input, InputAdornment, Select, MenuItem, Button, IconButton } from "@mui/material";
import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Refresh } from "@mui/icons-material";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CategoryModal from '../Inventory/CategoryModal';
import { fetchItemSubCategoriesByCategory, fetchItemTags } from '../../store/inventoryStore/inventoryThunk';
import { fetchSuppliers } from '../../store/supplierStore/supplierThunk';
import { fetchCustomers } from '../../store/customerStore/customerThunk';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { makeStyles } from "@material-ui/core/styles";
import { fetchAccountsByName } from "../../store/accountThunk";
import { fetchItemCategories } from '../../store/inventoryStore/inventoryThunk';

import { StyledStack } from './Filters.styles';
import { size } from 'lodash';
import { SearchIcon } from 'lucide-react';
import { Utils, VocuherCategory, VocuherTypes } from '../../utils/common-utils';

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    boxShadow: 'none',
    borderRadius: 7
  },
  toggleButtonGroup: {
    width: '100%',
  },
  toggleButton: {
    width: 15,
    height: 15,
    marginBottom: 2
  },

});

interface FilterProps {
  type: string;
  filterHandler: (data: any) => void;
  onShowDateRangeChange?: (show: boolean) => void;
}

//filters component.
const InventoryFilters: FC<FilterProps> = ({ type, filterHandler }) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { selectedAccount } = useAppSelector(state => state.auth);
  var date = new Date();
  // const [startDate, setStartDate] = useState<Date>((type === 'dashboard') ? new Date(date.getFullYear(), date.getMonth(), 1) : new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));
  const [startDate, setStartDate] = useState<Date>((type === 'dashboard') ? new Date(date.getFullYear(), date.getMonth(), 1) : new Date());
  const [endDate, setEndDate] = useState<Date>((type === 'dashboard') ? new Date(date.getFullYear(), date.getMonth() + 1, 0) : new Date());

  const [filterQuery, setFilterQuery] = useState("");
  const [filteroptions, setFilterOptions] = useState<IOptions[]>([]);
  const [options, setOptions] = useState<any[]>([]);
  const [selected, setSelected] = useState<any>();
  const [newOption, setNewOption] = useState("");
  const [closedSelect, setClosedSelect] = useState(true);
  const [statusSelected, setStatusSelected] = useState("all");
  const [dateFilterValue, setDateFilterValue] = useState("");
  const { startDateFY, endDateFY } = Utils.getFinancialYearDates();
  const [dateRange, setDateRange] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: null,
    endDate: null
  });

  // item category states for autocomplete
  const [itemCategoryOptions, setItemCategoryOptions] = useState<IOptions[]>([]);
  const [itemCategoryId, setItemCategoryId] = useState("");

  const [itemCategoryValue, setItemCategoryValue] = useState<HierarchicalOption | null>(null);
  const [itemSubCategoryOptions, setItemSubCategoryOptions] = useState<IOptions[]>([]);
  const [itemSubCategoryId, setItemSubCategoryId] = useState("");
  const [itemSubCategoryValue, setItemSubCategoryValue] = useState(null);

  const { subCategories } = useAppSelector(state => state.inventories);

  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState<IOptions | null>(null);
  const [editingSubCategory, setEditingSubCategory] = useState<any>(null);
  const [selectedCategoryForSubCat, setSelectedCategoryForSubCat] = useState<string>('');
  const [expandedCategories, setExpandedCategories] = useState<string[]>([]);


  const [selectedVoucherType, setSelectedVoucherType] = useState('all');
  const [showDateRange, setShowDateRange] = useState(false);

  const [selectedAmountRange, setSelectedAmountRange] = useState('all');
  const [amountRangeOptions, setAmountRangeOptions] = useState<IOptions[]>([
    { label: 'Amount Range', value: 'all' },
    { label: 'Below 1,000', value: '0 - 999' },
    { label: '1,000 - 5,000', value: '1000 - 5000' },
    { label: '5,001 - 10,000', value: '5001 - 10000' },
    { label: '10,001 - 50,000', value: '10001 - 50000' },
    { label: '50,001 - 1,00,000', value: '50001 - 100000' },
    { label: '1,00,001 - 3,00,000', value: '100000 - 300000' },
    { label: '3,00,001 - 5,00,000', value: '300001 - 500000' },
    { label: '5,00,001 - 7,00,000', value: '500001 - 700000' },
    { label: '7,00,001 - 9,00,000', value: '700001 - 900000' },
    { label: '9,00,001 & Above', value: '900001 & Above' }
  ]);

  // item tag states for autocomplete (replaces the Amount Range filter)
  const { tags } = useAppSelector(state => state.inventories);
  const [selectedTagId, setSelectedTagId] = useState('');
  const [selectedTagValue, setSelectedTagValue] = useState<TagOption | null>(null);

  // use form
  const methods = useForm<any>({});

  const createFilter = () => {
    console.log("--------- date range -------", dateRange);
    let filter = (filterQuery && filterQuery !== '') ? `&filter=${filterQuery}` : '';
    let voucherType = (selectedVoucherType && selectedVoucherType !== 'all') ? `&voucherType=${selectedVoucherType}` : '';
    let category = (itemCategoryId && itemCategoryId !== 'all' && itemCategoryId !== '') ? `&category=${itemCategoryId}` : '';
    let tag = (selectedTagId && selectedTagId !== '') ? `&tag=${selectedTagId}` : '';
    let status = (statusSelected && statusSelected !== 'all') ? `&status=${statusSelected}` : '';
    let dateParams = (dateRange.startDate && dateRange.endDate) ? `start=${dateRange.startDate}&end=${dateRange.endDate}` : '';
    let queryString = `${dateParams}${filter}${category}${tag}${voucherType}${status}`;
    filterHandler(queryString);
  };

  const onResetClickHandler = () => {
    setFilterQuery('');
    setSelectedAmountRange('all');
    setSelectedTagId('');
    setSelectedTagValue(null);
    setItemSubCategoryValue(null);
    setItemSubCategoryId('');
    setItemCategoryValue(null);
    setItemCategoryId('');
    setSelectedVoucherType('all');
    setStatusSelected('all');
    setDateRange({
      startDate: null,
      endDate: null
    });
    setDateFilterValue('');
    setClosedSelect(true);

    // Trigger filter creation with empty values
    setTimeout(() => {
      filterHandler('');
    }, 100);
  };

  const searchItems = async (searchValue: string) => {
    setFilterQuery(searchValue);
  }






  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    console.log("----- new date value from filter ----", newValue)
    if (name === 'startDate') {
      const s = { ...dateRange };
      s.startDate = newValue;
      setDateRange(s);
    } else if (name === 'endDate') {
      const s = { ...dateRange };
      s.endDate = newValue;
      setDateRange(s);
    }
  };

  //Fetch all the suppliers/Buyers list on page load.
  useEffect(() => {
    const getOptions = async () => {
      if (selectedAccount) {
        const { _id: id } = selectedAccount;
        const data: any = (type === 'account-payable') ? await dispatch(fetchSuppliers({ accountId: id, params: '' })) : await dispatch(fetchCustomers(id));
        const payload = Array.isArray(data?.payload) ? data.payload : [];

        if (payload.length > 0) {
          let option = [];
          option = payload.map((item: any) => {
            return { label: item.name, value: item._id }
          });
          option.push({ label: 'All', value: 'all' })
          setFilterOptions(option)
        } else {
          setFilterOptions([]);
        }
      }
    }
    getOptions();
  }, [dispatch, selectedAccount, type]);

  useEffect(() => {
    // Only create filter when at least one filter parameter is set
    if (filterQuery || selectedVoucherType !== 'all' || statusSelected !== 'all' || itemCategoryId || selectedTagId || (dateRange.startDate && dateRange.endDate)) {
      console.log("calling create filter");
      createFilter();
    }
  }, [dateRange, selectedVoucherType, filterQuery, statusSelected, itemCategoryId, selectedTagId]);

  const onInputChangeHandler = async (event: React.SyntheticEvent, value: string) => {
    setSelected('')
    setFilterQuery('');
    setNewOption(value);
    await dispatch(fetchAccountsByName(value)).unwrap().then((data) => {
      if (data) {
        // if(data.accounts.length > 0) {
        //   setOptions(data.accounts);
        // }
        setOptions(data.accounts);
      }
    });
  };

  const onCloseHandler = () => {
    setClosedSelect(true);
  };

  const onOpenHandler = () => {
    setClosedSelect(false);
  };

  const handleChangeVoucherType = (e: any) => {
    var _voucherTypeName = e.target.value;
    setSelectedVoucherType(_voucherTypeName);
  };

  const handleDateRange = (e: any) => {
    console.log(e.target.value);
    var _dateFilterName = e.target.value;
    // const _today = new Date();
    // const _quarter = Math.floor((_today.getMonth() / 3));
    // console.log(_quarter);

    // const startFullQuarter = new Date(today.getFullYear(), quarter * 3, 1);
    // const endFullQuarter = new Date(startFullQuarter.getFullYear(), startFullQuarter.getMonth() + 3, 0);

    if (e.target.value && e.target.value != '') {
      setDateFilterValue(e.target.value);
      if (_dateFilterName === 'Today') {
        setShowDateRange(false);
        setDateRange({
          startDate: new Date(Date.now()),
          endDate: new Date(Date.now())
        })

      } else if (_dateFilterName === 'Yesterday') {
        setShowDateRange(false);
        setDateRange({
          startDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
          endDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
        });
      } else if (_dateFilterName === 'This Week') {
        setShowDateRange(false);
        var curr = new Date();
        setDateRange({
          // startDate: new Date(curr.setDate(curr.getDate() - curr.getDay())),
          // endDate: new Date(curr.setDate(curr.getDate() - curr.getDay()+6)),
          startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
          endDate: new Date(Date.now())
        });
      } else if (_dateFilterName === 'Last Week') {
        setShowDateRange(false);
        setDateRange({
          startDate: new Date(Date.now() - 13 * 24 * 60 * 60 * 1000),
          endDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
        });
      } else if (_dateFilterName === 'This Month') {
        setShowDateRange(false);
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        setDateRange({
          startDate: new Date(y, m, 1),
          endDate: new Date(y, m + 1, 0)
        });
      } else if (_dateFilterName === 'Last Month') {
        setShowDateRange(false);
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        setDateRange({
          startDate: new Date(y, m - 1, 1),
          endDate: new Date(y, (m - 1) + 1, 0)
        });
      } else if (_dateFilterName === 'FY Q1') {
        setShowDateRange(false);
        const _quarter = 1;
        const qStartDate = new Date(startDateFY.getFullYear(), _quarter * 3, 1);
        const qEndDate = new Date(qStartDate.getFullYear(), qStartDate.getMonth() + 3, 0);

        setDateRange({
          startDate: qStartDate,
          endDate: qEndDate
        });
      } else if (_dateFilterName === 'FY Q2') {
        setShowDateRange(false);
        const _quarter = 2;
        const qStartDate = new Date(startDateFY.getFullYear(), _quarter * 3, 1);
        const qEndDate = new Date(qStartDate.getFullYear(), qStartDate.getMonth() + 3, 0);
        setDateRange({
          startDate: qStartDate,
          endDate: qEndDate
        });
      } else if (_dateFilterName === 'FY Q3') {
        setShowDateRange(false);
        const _quarter = 3;
        const qStartDate = new Date(startDateFY.getFullYear(), _quarter * 3, 1);
        const qEndDate = new Date(qStartDate.getFullYear(), qStartDate.getMonth() + 3, 0);
        setDateRange({
          startDate: qStartDate,
          endDate: qEndDate
        });
      } else if (_dateFilterName === 'FY Q4') {
        setShowDateRange(false);
        const _quarter = 0;
        const qStartDate = new Date(endDateFY.getFullYear(), _quarter * 3, 1);
        const qEndDate = new Date(qStartDate.getFullYear(), qStartDate.getMonth() + 2, 31);
        // Date.today().clearTime().moveToFirstDayOfMonth();
        setDateRange({
          startDate: qStartDate,
          endDate: qEndDate
        });
      } else if (_dateFilterName === 'This Year') {
        setShowDateRange(false);
        setDateRange({
          startDate: new Date(startDateFY),
          endDate: new Date(endDateFY)
        });
      } else if (_dateFilterName === 'Custom') {
        setShowDateRange(true);
      } else {
        setShowDateRange(false);
        setDateRange({
          startDate: null,
          endDate: null
        });
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    const getItemCategories = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchItemCategories());
      console.log('fetchItemCategories payload:', data.payload);
      if (data.payload && data.payload.length > 0) {

        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.name, value: item._id })
        });
        if (isMounted && options.length > 0) {
          setItemCategoryOptions(options);
        }
      }
    }
    getItemCategories();
    return () => {
      isMounted = false;
    };

  }, []);

  // Fetch tags (appliesTo SKU) on load for the Tag filter autocomplete
  useEffect(() => {
    dispatch(fetchItemTags());
  }, [dispatch]);

  // --- Tag filter (replaces Amount Range) ---
  // Read-only picker: tags are created and edited from the Tags master
  // in Settings, not from this filter.
  type TagOption = {
    label: string;
    value: string;
    _id?: string;
    description?: string;
    color?: string;
  };

  const buildTagOptions = (): TagOption[] => {
    const options: TagOption[] = [];
    tags.forEach(tag => {
      options.push({ label: tag.name, value: tag._id, _id: tag._id, description: tag.description, color: tag.color });
    });
    return options;
  };

  const onChangeTag = (data: TagOption | null) => {
    setSelectedTagValue(data && data.value ? data : null);
    setSelectedTagId(data?.value || '');
  };

  const onChangeCategory = (data: HierarchicalOption | null) => {
    setItemCategoryValue(data);
    setItemCategoryId(data?.value || '');
  }

  // --- Helper functions for hierarchical category/subcategory dropdown ---
  // Use a custom type for hierarchical options
  type HierarchicalOption = {
    label: string;
    value: string;
    isAddOption?: boolean;
    isSubCategory?: boolean;
    hasSubCategories?: boolean;
    _id?: string;
    parentCategory?: string;
    disable?: boolean;
  };

  const buildHierarchicalOptions = (): HierarchicalOption[] => {
    const options: HierarchicalOption[] = [{ label: '+ Add Category', value: 'add_category', isAddOption: true }];
    itemCategoryOptions.forEach(category => {
      const subCats = subCategories.filter(sub => sub.category === category.value);
      options.push({
        ...category,
        isSubCategory: false,
        hasSubCategories: subCats.length > 0
      });
      // Add sub-categories for this category if expanded
      if (expandedCategories.includes(category.value) && subCats.length > 0) {
        subCats.forEach(subCat => {
          options.push({
            label: subCat.name,
            value: subCat._id,
            _id: subCat._id,
            isSubCategory: true,
            parentCategory: category.value
          });
        });
      }
    });
    console.log('Category/Subcategory options:', options);
    return options;
  };

  const handleOptionClick = (e: any, option: any) => {
    if (option.isAddOption) {
      e.stopPropagation();
      setShowCategoryModal(true);
      setEditingCategory(null);
    } else if (!option.isSubCategory) {
      // Toggle expansion for main categories
      if (expandedCategories.includes(option.value)) {
        setExpandedCategories(prev => prev.filter(id => id !== option.value));
      } else {
        setExpandedCategories(prev => [...prev, option.value]);
        // Fetch sub-categories for this category
        dispatch(fetchItemSubCategoriesByCategory(option.value));
      }
    }
  };

  const handleEditCategory = (e: any, option: any) => {
    e.stopPropagation();
    const categoryToEdit = itemCategoryOptions.find(cat => cat.value === option.value);
    setEditingCategory(categoryToEdit ?? null);
    setShowCategoryModal(true);
  };

  const handleEditSubCategory = (e: any, option: any) => {
    e.stopPropagation();
    const subCatToEdit = subCategories.find(sub => sub._id === option._id);
    setEditingSubCategory(subCatToEdit);
    setShowCategoryModal(true);
  };

  const handleAddSubCategory = (e: any, option: any) => {
    e.stopPropagation();
    setSelectedCategoryForSubCat(option.value);
    setEditingSubCategory(null);
    setShowCategoryModal(true);
  };


  return (
    <>
      {/* {JSON.stringify(filteroptions)} */}
      {/* <StyledStack> */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title={'Reset Filter'}>
          <IconButton onClick={() => { onResetClickHandler(); }}
            style={{ marginRight: '15px', marginLeft: '5px', color: '#488dff', backgroundColor: '#fff', border: '3px solid #e9ecf1' }}
            size='small' ><Refresh /></IconButton>
        </Tooltip>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <FormProvider {...methods}>


            <TextField className='c-text-field-3'
              variant="standard"
              style={{ width: 300 }}
              size='small'
              value={filterQuery}
              placeholder='Search Name, Description, Item Code ...'
              onChange={(e) => searchItems(e.target.value.toString())}
              InputProps={{
                disableUnderline: true,
                startAdornment: <InputAdornment position="start"><SearchIcon style={{ marginTop: -3 }} size={20} /></InputAdornment>,
                style: {
                  fontSize: 14,
                  fontWeight: 'normal',
                },
              }}
            />

          <>
            <Autocomplete
              id="Search Category"
              disablePortal
              disableClearable
              style={{ width: 200, float: 'right', marginLeft: '10px', backgroundColor: '#fff' }}
              value={itemCategoryValue as HierarchicalOption | undefined}
              options={buildHierarchicalOptions()}
              getOptionLabel={(option) => option.label}

              // Add this to ensure dropdown closes after selection
              disableCloseOnSelect={false}

              renderOption={(props, option: any) => (
                <li {...props}
                  style={{
                    fontSize: 14,
                    height: 40,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: option.isAddOption ? '#488dff' : 'inherit',
                    fontWeight: option.isAddOption ? 'bold' : 'normal',
                    paddingLeft: option.isSubCategory ? '32px' : '16px',
                    backgroundColor: option.isSubCategory ? '#f8f9fa' : 'transparent',
                    cursor: option.isAddOption ? 'pointer' : 'default'
                  }}
                >
                  {/* Category/subcategory label */}
                  <span
                    style={{ flex: 1 }}
                  >
                    {option.label}
                  </span>
                  <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                    {/* Subcategory row: only edit icon */}
                    {!option.isAddOption && option.isSubCategory && (
                      <EditIcon
                        style={{ fontSize: 12, color: '#488dff', cursor: 'pointer' }}
                        onClick={e => { e.stopPropagation(); handleEditSubCategory(e, option); }}
                      />
                    )}
                    {/* Category row: edit, add subcat, and expand/collapse arrow */}
                    {!option.isAddOption && !option.isSubCategory && (
                      <>
                        <EditIcon
                          style={{ fontSize: 12, color: '#488dff', cursor: 'pointer' }}
                          onClick={e => { e.stopPropagation(); handleEditCategory(e, option); }}
                        />
                        <AddIcon
                          style={{ fontSize: 12, color: '#49a563', cursor: 'pointer' }}
                          onClick={e => { e.stopPropagation(); handleAddSubCategory(e, option); }}
                        />
                        <span
                          style={{ cursor: 'pointer', marginLeft: 4, fontSize: 10, userSelect: 'none' }}
                          onClick={e => {
                            e.stopPropagation();
                            if (expandedCategories.includes(option.value)) {
                              setExpandedCategories(prev => prev.filter(id => id !== option.value));
                            } else {
                              setExpandedCategories(prev => [...prev, option.value]);
                              dispatch(fetchItemSubCategoriesByCategory(option.value));
                            }
                          }}
                        >
                          {expandedCategories.includes(option.value) ? '▼' : '▶'}
                        </span>
                      </>
                    )}
                  </div>
                </li>
              )}

              onChange={(event, value) => {
                if (value && value.isAddOption) {
                  // For "Add Category" option, open modal but don't set as selected value
                  setShowCategoryModal(true);
                  setEditingCategory(null);
                  // Don't change the current selection
                  return;
                } else if (value && !value.isSubCategory) {
                  // For regular category selection
                  onChangeCategory(value);
                } else if (value && value.isSubCategory) {
                  // For subcategory selection
                  onChangeCategory(value);
                } else if (!value) {
                  // Handle clearing the selection
                  onChangeCategory({ label: '', value: '' });
                }
              }}

              classes={{ paper: classes.paper }}
              renderInput={(params) => <TextField {...params}
                className='c-text-field-3'
                variant="standard"
                name="search"
                size='small'
                placeholder="Select Category"
                InputProps={{ ...params.InputProps, disableUnderline: true }}
              />}
            />

            {/* Amount Range filter replaced by the Tag filter below.
            <Select
              name="Amount Range"
              disableUnderline
              MenuProps={{
                PaperProps: {
                  sx: {
                    border: "1.5px solid #e9ecf1",
                    boxShadow: 'none',
                    borderRadius: '5px'
                  }
                }
              }}
              sx={{
                boxShadow: "none",
                width: 150,
                ml: '10px !important',
                pt: '0px !important',
                pl: '10px !important',
                '& .MuiOutlinedInput-input': { p: 0, m: 0 },
                '& .MuiSelect-select': { p: 0 },
                ".MuiOutlinedInput-notchedOutline": { border: 0 },
                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  border: 0,
                },
                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  border: 0,
                },
              }}
              label="Statuses"
              className='c-text-field-3'
              id="status"
              variant="outlined"
              value={selectedAmountRange}
              defaultValue={'all'}
              onChange={(event: SelectChangeEvent<any>) => { setSelectedAmountRange(event.target.value); }} >
              {amountRangeOptions.map(option => (
                <MenuItem
                  value={option.value}
                  key={option.value}
                  disabled={option.disable || false}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            */}

            {/* Tag filter — works like the Category filter (add/update inline) */}
            <Autocomplete
              id="Search Tag"
              disablePortal
              style={{ width: 200, marginLeft: '10px', backgroundColor: '#fff' }}
              value={selectedTagValue}
              options={buildTagOptions()}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderOption={(props, option: any) => (
                <li {...props}
                  style={{
                    fontSize: 14,
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '16px',
                  }}
                >
                  <span style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{
                      width: 10, height: 10, borderRadius: '50%',
                      backgroundColor: option.color || '#7f8c9b',
                      display: 'inline-block', flexShrink: 0
                    }} />
                    {option.label}
                  </span>
                </li>
              )}
              onChange={(event, value) => {
                onChangeTag(value || null);
              }}
              classes={{ paper: classes.paper }}
              renderInput={(params) => <TextField {...params}
                className='c-text-field-3'
                variant="standard"
                name="searchTag"
                size='small'
                placeholder="Select Tag"
                InputProps={{ ...params.InputProps, disableUnderline: true }}
              />}
            />
          </>

          <Select
            name="date"
            disableUnderline
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1.5px solid #e9ecf1",
                  boxShadow: 'none',
                  borderRadius: '5px'
                }
              }
            }}
            value={dateFilterValue}
            defaultValue={dateFilterValue}
            sx={{
              boxShadow: "none",
              width: 200,
              ml: '10px !important',
              pt: '0px !important',
              pl: '10px !important',
              color: '#666',
              '& .MuiOutlinedInput-input': { p: 0, m: 0 },
              '& .MuiSelect-select': { p: 0, color: '#666' },
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            }}
            label="Select Date"
            className='c-text-field-3'
            id="status"
            variant="outlined"
            // value={statusSelected}
            onChange={(e) => { handleDateRange(e) }}
          >
            <MenuItem value={''} key={''}> Select Date</MenuItem>
            <MenuItem value={'Today'} key={'Today'}> Today </MenuItem>
            <MenuItem value={'Yesterday'} key={'Yesterday'}> Yesterday </MenuItem>
            <MenuItem value={'This Week'} key={'This Week'}> This Week </MenuItem>
            <MenuItem value={'Last Week'} key={'Last Week'}> Last Week </MenuItem>
            <MenuItem value={'This Month'} key={'This Month'}> This Month </MenuItem>
            <MenuItem value={'Last Month'} key={'Last Month'}> Last Month </MenuItem>
            <MenuItem value={'FY Q1'} key={'FY Q1'}> FY Q1 (Apr - Jun) </MenuItem>
            <MenuItem value={'FY Q2'} key={'FY Q2'}> FY Q2 (Jul - Sept) </MenuItem>
            <MenuItem value={'FY Q3'} key={'FY Q3'}> FY Q3 (Oct - Dec) </MenuItem>
            <MenuItem value={'FY Q4'} key={'FY Q4'}> FY Q4 (Jan - Mar) </MenuItem>
            <MenuItem value={'This Year'} key={'This Year'}> This Year </MenuItem>
            {/* <MenuItem value={'Last Year'} key={'Last Year'}> Last Year </MenuItem>
                    <MenuItem value={'FY 23-24'} key={'FY 23-24'}> FY 23-24 </MenuItem>
                    <MenuItem value={'FY 24-25'} key={'FY 24-25'}> FY 24-25 </MenuItem> */}
            <MenuItem value={'Custom'} key={'Custom'}> Custom Date </MenuItem>
          </Select>
          </FormProvider>
        </LocalizationProvider>
      </div>

      {showDateRange && (
        <div style={{ display: 'flex', alignItems: 'center', paddingTop: '10px', paddingLeft: '60px', width: '100%' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <FormProvider {...methods}>
              <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: 14,
                    height: 28
                  },
                }}
                renderInput={(params) =>
                  <TextField {...params}
                    required
                    className='c-text-field-3'
                    variant="standard"
                    sx={{ width: 150 }}
                    size='small'
                    placeholder="Start Date"

                  />}
                value={dateRange.startDate || null}
                onChange={(value) => { handleDateChange(value, 'startDate') }}
              />
              <span style={{ marginRight: 10 }} />
              <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: 14,
                    height: 28
                  },
                }}
                renderInput={(params) =>
                  <TextField {...params}
                    required
                    className='c-text-field-3'
                    variant="standard"
                    sx={{ width: 150 }}
                    size='small'
                    placeholder="End Date"

                  />}
                value={dateRange.endDate || null}
                onChange={(value) => { handleDateChange(value, 'endDate') }}
              />
            </FormProvider>
          </LocalizationProvider>
        </div>
      )}

      {showCategoryModal && (
        <CategoryModal
          open={showCategoryModal}
          onClose={() => {
            setShowCategoryModal(false);
            setEditingCategory(null);
            setEditingSubCategory(null);
            setSelectedCategoryForSubCat('');
          }}
          editingCategory={editingCategory}
          editingSubCategory={editingSubCategory}
          selectedCategoryId={selectedCategoryForSubCat}
          categories={itemCategoryOptions}
          isSubCategory={!!editingSubCategory || !!selectedCategoryForSubCat}
          onSuccess={() => {
            if (selectedCategoryForSubCat) {
              dispatch(fetchItemSubCategoriesByCategory(selectedCategoryForSubCat));
            } else {
              dispatch(fetchItemCategories());
            }
          }}
        />
      )}
    </>
  );
}

export default InventoryFilters;
